import clsx from 'clsx';
import type { ReactNode } from 'react';

interface FieldProps {
  label: string;
  hint?: string;
  error?: string | null;
  className?: string;
  children: ReactNode;
}

export function Field({ label, hint, error, className, children }: FieldProps) {
  return (
    <label className={clsx('block space-y-1.5', className)}>
      <span className="block font-mono text-[10px] font-medium uppercase tracking-[0.15em] text-text-muted">
        {label}
      </span>
      {children}
      {hint && !error && (
        <span className="block text-[11px] text-text-muted">{hint}</span>
      )}
      {error && (
        <span role="alert" className="block text-[11px] text-danger">{error}</span>
      )}
    </label>
  );
}
